// extracted by mini-css-extract-plugin
export default {"position":"zLmkN8c0","position--left":"hy86Jkbs","position--center":"MSgWSpmC","position--right":"vTT3yVBg"};